import { useEffect, useState } from 'react';
import { Smartphone, Globe } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

// "App version" block for the My Account menu: installed BBC app version (via the Android bridge) or "Web",
// plus the latest published APK so staff can see at a glance whether they are up to date.
export function AppVersionInfo() {
  const [latest, setLatest] = useState(null);
  const bridge = typeof window !== 'undefined' ? window.AndroidBridge : null;
  let installed = null;
  try { installed = bridge && typeof bridge.getVersionName === 'function' ? bridge.getVersionName() : null; } catch (e) { installed = null; }

  useEffect(() => {
    fetch(`${API}/api/app/latest-version`).then((r) => (r.ok ? r.json() : null)).then((d) => { if (d) setLatest(d); }).catch(() => {});
  }, []);

  const behind = installed && latest?.version_name && installed !== latest.version_name;
  return (
    <div className="flex flex-col gap-0.5 text-xs" data-testid="app-version-info">
      <div className="flex items-center gap-2">
        {installed ? <Smartphone className="w-3.5 h-3.5 text-muted-foreground" /> : <Globe className="w-3.5 h-3.5 text-muted-foreground" />}
        <span className="text-muted-foreground">App version:</span>
        <code className="font-mono text-[11px]" data-testid="app-version-installed">{installed ? `v${installed}` : 'Web'}</code>
        {behind && <span className="px-1.5 py-0.5 rounded-full bg-amber-100 text-amber-800 text-[10px] font-medium" data-testid="app-version-behind">Update available</span>}
      </div>
      {latest?.version_name && (
        <div className="flex items-center gap-2 pl-[22px]">
          <span className="text-muted-foreground">Latest Android app:</span>
          {behind && latest.apk_url ? (
            <a href={latest.apk_url} className="font-mono text-[11px] underline text-forest-700" data-testid="app-version-latest">v{latest.version_name}</a>
          ) : (
            <code className="font-mono text-[11px]" data-testid="app-version-latest">v{latest.version_name}</code>
          )}
        </div>
      )}
    </div>
  );
}
